export default __webpack_public_path__ + "static/media/illustration-intro.cb9a8a95.svg";